import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './StoreFacility.scss'

class StoreFacility extends PureComponent {
  render () {
    if (this.props.services.has_wheelchair_accessible_entrance || this.props.services.has_wheelchair_accessible_elevator) {
      return (
        <div className='store-facility'>
          <h2 className='sf-title' tabIndex={this.props.tabbable ? 0 : -1}>In this store you'll find...</h2>
          <ul className='sf-service-list list-unstyled'>
            <li className='sf-service'>
              <span className={`sf-icon sr-hidden argos-icon sf-icon-accessible`} aria-hidden='true' />
              <span className='sf-name' tabIndex={this.props.tabbable ? 0 : -1}>accessible</span>
            </li>
          </ul>
          <hr />
        </div>
      )
    } else {
      return null
    }
  }
}

StoreFacility.defaultProps = {
  tabbable: false
}

StoreFacility.propTypes = {
  services: PropTypes.object,
  tabbable: PropTypes.bool
}

export default StoreFacility



// WEBPACK FOOTER //
// ./src/components/StoreFacility/StoreFacility.jsx